import Vue from 'vue'
import Vuex from 'vuex'

import { service } from '@/api/Rest'

import * as getters from './getters'
import mutations from './mutations'
import * as actions from './actions'
import todaModule from './modules/today.js'
Vue.use(Vuex)

var store= new Vuex.Store({
  state: {
    actionLoader:false,
    integrations:[],
    areas:[],
    allBoards:[],
    allPipelines:[],
    allBusiness:[],
    allTeams:[],
    allBranchs:[],
    actualArea:{},
    actualDatagroup:{},
    actualBranch:null,
    actualBranchId:localStorage.getItem('actualBranchId'),
    boards:[],
    currentUser:{},
    actualTeam:{},
    board:{
      pipelines:[],
      cards:[]
    },
    members:[],
    datagroups:[],
    packdata:{
      results:[]
    },
    schemeList:[],
    actualScheme:{},
    notifications:[],
    integrationsHub:[],
    sharelinkdetail:{},
    targets:[],
    colortags:[],
    currentProxycard:{},
    operators:[

      {
        name: "Igual a",
        id: "=="
      },
      {
        name: "Mayor que",
        id: ">"
      },
      {
        name: "Mayor igual que",
        id: ">="
      },
      {
        name: "Menor que",
        id: "<"
      },
      {
        name: "Menor igual que",
        id: "<="
      },
      {
        name: "Contiene",
        id: "match"
      }
    ],
    activeColumnModal:false,
    actualPipeline:null
  },
  getters,
  mutations,
  actions,
  modules:{
    'today':todaModule
  }
})
store.$api=service;
export default store;